import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { SimpleInputModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'iw-bank-transfer-inr-form',
  imports: [ReactiveFormsModule, SimpleInputModule, TranslateModule],
  templateUrl: './bank-transfer-inr-form.component.html',
  styleUrl: './bank-transfer-inr-form.component.scss',
})
export class BankTransferInrFormComponent {
  form = input<FormGroup>();
}
